import { UserAgentDataType, IKameleoonData, KameleoonData } from './types';
import { TrackingStatus } from 'src/types';

/**
 * @class
 * UserAgent - a class for creating an instance for user agent
 * */
export class UserAgent implements IKameleoonData {
  public status: TrackingStatus;

  private value: string;

  constructor(value: string) {
    this.value = value;
    this.status = TrackingStatus.Sent;
  }

  get url(): string {
    return '';
  }

  get data(): UserAgentDataType {
    return {
      value: this.value,
      type: KameleoonData.UserAgent,
      status: this.status,
    };
  }
}
